import { AuthenticatedLayout } from "features/common/components/AuthendicatedLayout";
import { ReportPreview } from "features/report/components/ReportPreview";

export const InternalReconciliation = () => {
  return (
    <AuthenticatedLayout>
      <ReportPreview action="RECONCILIATION" />
    </AuthenticatedLayout>
  );
};
